import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export default function TrendChart({ series = [], height = 180, width = 560 }) {
    if (!series.length) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height }}>
                <Typography variant="body2" color="text.secondary">
                    Keine Daten im ausgewählten Zeitraum.
                </Typography>
            </Box>
        );
    }

    const padding = 32;
    const step = series.length > 1 ? (width - padding * 2) / (series.length - 1) : 0;
    const values = series.flatMap((item) => [item.income, item.expense, item.result]);
    const min = Math.min(...values, 0);
    const max = Math.max(...values, 0);
    const range = max - min || 1;

    const scaleY = (value) => {
        return height - padding - ((value - min) / range) * (height - padding * 2);
    };

    const buildPath = (key) => {
        return series
            .map((item, index) => {
                const x = padding + index * step;
                const y = scaleY(item[key]);
                return `${index === 0 ? 'M' : 'L'}${x},${y}`;
            })
            .join(' ');
    };

    const axisY = scaleY(0);

    return (
        <Box sx={{ position: 'relative', width, height }}>
            <svg width={width} height={height} role="img" aria-label="Verlauf Einnahmen und Ausgaben">
                <line x1={padding} x2={width - padding} y1={axisY} y2={axisY} stroke="#9e9e9e" strokeDasharray="4 6" />
                <path d={buildPath('income') || ''} fill="none" stroke="#2e7d32" strokeWidth={3} />
                <path d={buildPath('expense') || ''} fill="none" stroke="#c62828" strokeWidth={3} />
                <path d={buildPath('result') || ''} fill="none" stroke="#1565c0" strokeWidth={3} strokeDasharray="6 4" />
            </svg>
            <Box sx={{ position: 'absolute', top: 8, right: 16, display: 'flex', gap: 2 }}>
                <Chip size="small" label="Einnahmen" sx={{ backgroundColor: 'rgba(46,125,50,0.1)', color: '#2e7d32' }} />
                <Chip size="small" label="Ausgaben" sx={{ backgroundColor: 'rgba(198,40,40,0.1)', color: '#c62828' }} />
                <Chip size="small" label="Ergebnis" sx={{ backgroundColor: 'rgba(21,101,192,0.1)', color: '#1565c0' }} />
            </Box>
        </Box>
    );
}
